import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import { isBrowser } from 'react-device-detect';
import { toast } from 'react-toastify';
import { logger } from './utils/logger';

type ErrorBoundaryProps = {
    children: React.ReactNode;
  };

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const errorHandler = (event: any) => {
      handleMoveLogin()
      logger.error("ErrorBoundary caught an error", event.error);

    };

    window.addEventListener('error', errorHandler);
    window.addEventListener('unhandledrejection', errorHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
      window.removeEventListener('unhandledrejection', errorHandler);
    };
  }, [navigate]);

  const handleMoveLogin = () => {
    // navigate('/userlogin')  
     toast.error('A new load is required. Please be patient.')
    if (!isBrowser) {
        if(window.ReactNativeWebView !== undefined)
          window.ReactNativeWebView.postMessage(JSON.stringify({ 'type': 'reload' }));
        else if(window.Android !== undefined)
          window.Android.postMessage(JSON.stringify({ 'type': 'reload' }));
    }
  }

  return <>{children}</>;
};

export default ErrorBoundary;
